<template>
  	<div class="" id="app">
      <div :style="style">
        <view-header></view-header>
        <router-view></router-view>
        <viewFoot></viewFoot>
      </div>
      
  	</div>
</template>

<script>
import viewHeader from './components/header.vue'
import viewFoot from './components/footer.vue'

export default {
  	name: 'App', 
    components:{
      viewHeader,viewFoot
    }, 
  data(){
    return{
			style:{},
      
    }
   
  },
  created() {
		
	},
  mounted() {
    
  },

  methods: {
    updateElementStyle() {
      const availWidth = window.screen.availWidth;
      const innerWidth = window.innerWidth;
      console.log(availWidth, innerWidth);

      if (availWidth < 1440) {
        let num = availWidth / 1440;
        this.elementStyle = {
          width: '1440px',
          position: 'absolute',
          top: '0',
          left: '50%',
          transformOrigin: 'top left',
          transform: `scale(${num}) translate(-50%, 0)`
        };
      } else {
        this.elementStyle = {
          width: '100%',
          position: 'relative',
          transform: 'none',
          left: '0',
          top: '0'
        };
      }
    }
  },

}
</script>

<style>
   /* ::-webkit-scrollbar {
     width: 0 !important;
   }
   ::-webkit-scrollbar {
     width: 0 !important;height: 0;
   } 
  overflow-x:hidden; 隐藏横的
     
   
   
   */
   

body{
	margin: 0;
  color: #191919;
  background: #F5F7FA;
  overflow-x:hidden; 
}
@media screen and (max-width: 1440px) {
	html,
	body {
		width: 100%;
	}
	#app{
		position: relative;
		width: 1440px;
	}
}
#app {
	width: 100vw;
	height: 100vh;
}
.ls-flex-center{
		display: flex;
		align-items: center;
		justify-content: center;
	}
  .ls-flex-center{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ls-flex-col-center{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

  .fs-14{
		font-size: 0.875rem !important;
		
	}
	.fs-16{
		font-size: 1rem !important;
	}
	.fs-18{
		font-size: 1.125rem !important;
	}
	.fs-20{
		font-size: 1.25rem !important;
	}
	.fs-22{
		font-size: 1.375rem !important;
	}


  .max-width{
		width: 1350px;
		@media screen and (max-width: 1350px) {
			/* padding-left: 30px;
			padding-right: 30px; */
		}
	}

</style>
